import React from 'react';
import { styled } from '@mui/material/styles';


const sizeMap = {
  sm: 'auto',
  md: '42px',
  lg: '48px',
};


const Base = React.forwardRef<any, any>(({ children, component: Component = 'button', ...props }, ref) => (
  <Component ref={ref} {...props}>
    {children}
  </Component>
));


const StyledButton = styled(Base, {
  shouldForwardProp: (prop) => prop !== 'sizevariant'
})<{ sizevariant?: 'sm' | 'md' | 'lg' }>(({ sizevariant = 'sm' }) => ({
  width: sizeMap[sizevariant],
  height: sizevariant === 'sm' ? 'auto' : sizeMap[sizevariant],
  position: 'relative',
  padding: '10px 20px',
  borderRadius: '50rem',
  background: 'linear-gradient(25deg,rgba(10, 98, 116, 0.69) 10%,rgba(19, 185, 218, 0.66))',
  color: 'white',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0px 2px 10px rgba(0,0,0,0.4)',
  transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
  fontWeight: 500,
  textDecoration: 'none',
  fontSize: '16px',
  border: 'none',
  cursor: 'pointer',
  zIndex: 1,
  backdropFilter: 'blur(10px)',
  backgroundClip: 'padding-box',
  textTransform: 'none',

  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    padding: '1px',
    borderRadius: '50rem',
    background: 'linear-gradient(180deg, rgb(0,255,255,0.5),rgba(10, 98, 116, 0.66))',
    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
    zIndex: -1,
    transition: 'opacity 0.3s ease',
  },

  '&:hover': {
    background: 'linear-gradient(25deg, #09475B 10%, #0A9DB7)',
    boxShadow: '0px -1px 6px rgba(226, 226, 226, 0.44)',
    '&::before': {
      background: 'linear-gradient(180deg, #0ff, #0A6274)',
    },
  },

  '&:active': {
    background: 'linear-gradient(25deg,rgba(10, 98, 116, 0.66) 0%, #0AC5E8)',
    boxShadow: '0px 4px 12px rgba(0,0,0,0.5)',
    '&::before': {
      background: 'linear-gradient(180deg, #13B8DA, #0A6274)',
    },
  },
}));

type BlueButtonProps = {
  onClick?: () => void;
  href?: string;
  sizevariant?: 'sm' | 'md' | 'lg';
  component?: React.ElementType;
  children: React.ReactNode;
  [key: string]: any; 
};

const BlueButton: React.FC<BlueButtonProps> = ({
  onClick,
  href,
  sizevariant = 'sm',
  component = 'button',
  children,
  ...rest
}) => {

  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
        <StyledButton sizevariant={sizevariant} component="div">
          {children}
        </StyledButton>
      </a>
    );
  }

  return (
    <StyledButton
      component={component}
      sizevariant={sizevariant}
      onClick={onClick}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export default BlueButton;
